module.exports = __webpack_public_path__ + "static/media/game_son.2a4f92c6.png";